import { Loader } from '@components/loader';
import { useTdsMerchantsTable } from '@components/tables/tdsMerchants';
import { BaseLayout } from '@layouts/base';
import { useList } from '@services/staff/tdsMerchants/list';
import { useNavigate, useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export function TdsMerchantsPage() {
  const { t } = useTranslation('app');
  const { localId } = useParams({ strict: false });
  const navigate = useNavigate();
  const { data, isPending } = useList();

  function handleLinkedMerchantSelect(merchantId: string) {
    navigate({
      to: '/u/$localId/staff/merchants/$merchantId/orders',
      params: { merchantId, localId: localId || '' },
    }).catch((err) => console.error(err));
  }

  function handleRowSelect(id: string) {
    navigate({
      to: '/u/$localId/staff/tds-merchants/$id',
      params: { id, localId: localId || '' },
    }).catch((err) => console.error(err));
  }

  const { Table } = useTdsMerchantsTable({
    data,
    onRowSelect: handleRowSelect,
    onLinkedMerchantSelect: handleLinkedMerchantSelect,
  });

  if (isPending) return <Loader />;

  return (
    <BaseLayout title={t('pages.tdsMerchants.title')}>
      <Table />
    </BaseLayout>
  );
}
